import { call, select, put, takeLatest, all } from "redux-saga/effects";
import api from "../../Environment";
import { createNotification } from "react-redux-notify";
import { getErrorNotificationMessage } from "../../components/helper/NotificationMessage";
import {
  fetchPayoutServicesFailure,
  fetchPayoutServicesSuccess,
  masspayWithdrawFailed,
  masspayWithdrawSuccess,
} from "../actions/PayoutAction";
import { FETCH_PAYOUT_SERVICES_START, INITIATE_PAYOUT_TABLE, MASSPAY_WITHDRAW_AMOUNT_IS_LESS } from "../../store/actions/ActionConstant";
import { fetchPayoutAttributesFailure } from "../../store/actions/PayoutAction";
import { FETCH_PAYOUT_ATTRIBUTES_START } from "../../store/actions/ActionConstant";
import { fetchPayoutAttributesSuccess, updatePayoutInfoWithMaxAmount ,fetchWithdrawalInvoiceEnd} from "../../store/actions/PayoutAction";
import { FETCH_PAYOUT_DRAFT_START } from "../../store/actions/ActionConstant";
import { fetchPayoutDraftSuccess } from "../../store/actions/PayoutAction";
import { fetchPayoutDraftFailure } from "../../store/actions/PayoutAction";
import { CONFIRM_PAYOUT_DRAFT_START } from "../../store/actions/ActionConstant";
import { confirmPayoutDraftFailure } from "../../store/actions/PayoutAction";
import { confirmPayoutDraftSuccess } from "../../store/actions/PayoutAction";
import { fetchWalletDetailsStart } from "../../store/actions/WalletAction";
import { getSuccessNotificationMessage ,getWarningNotificationMessage} from "../../components/helper/NotificationMessage";
import { push } from "../../helpers/navigation/navigationService";
import { initiatePayoutSuccess } from "../../store/actions/PayoutAction";
import { initiatePayoutFailure } from "../../store/actions/PayoutAction";
import { INITIATE_PAYOUT_START } from "../../store/actions/ActionConstant";
import { WITHDRAWAL_CONFIRM_DOWNLOAD_START  } from "../../store/actions/ActionConstant";
import masspayService from '../../helpers/services/payment/masspay.service'
import invoiceService from '../../helpers/services/invoice/withdrawalInvoiceDownload.service'
import { showErrorComponent } from "../actions/ComponentAction";
import { parsePaymentServiceError } from "../../helpers/services/payment/error";

/** @param {'masspaySetup' | 'request'} phase */
function* putInitiatePayoutErrorEffects(error, phase) {
  yield put(initiatePayoutFailure(error));
  const status = error?.response?.status;

  if (phase === "masspaySetup") {
    if (status !== 400) {
      yield put(
        showErrorComponent({
          error,
          status: status ?? 500,
        })
      );
    }
    const message = error.response
      ? parsePaymentServiceError(error.response)
      : error.message;
    yield put(createNotification(getErrorNotificationMessage(message)));
  } else {
    if (![400, 500].includes(status)) {
      yield put(
        showErrorComponent({
          error,
          status: status ?? 500,
        })
      );
    }
    const message = error?.response?.data?.errors || error.message;
    yield put(createNotification(getErrorNotificationMessage(message)));
  }
}

function* initiatePayoutActionAPI() {
  try {
    const payout = yield select((state) => state.payoutModel.payout);

    try {
      yield masspayService.setupMasspayUser();
    } catch (error) {
      yield* putInitiatePayoutErrorEffects(error, "masspaySetup");
      return;
    }
    const response = yield api.postAuthMethod("masspay/initiate", {
      amount: payout.amount,
    });

    if (response.data.success) {
      if (response.data.redirect) {
        yield put(initiatePayoutSuccess(response.data.data));
        yield push("wallet/payouts");
      } else {
        yield put(fetchWalletDetailsStart());
        const notificationMessage = getWarningNotificationMessage(
          response.data.message
        );
        yield put(createNotification(notificationMessage));
        yield put(updatePayoutInfoWithMaxAmount());
      }

    } else {
      yield put(initiatePayoutFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield* putInitiatePayoutErrorEffects(error, "request");
  }
}

function* initiateTablePayoutActionAPI() {
  try {
    const payout = yield select((state) => state.payoutModel.payout);

    try {
      yield masspayService.setupMasspayUser();
    } catch (error) {
      yield* putInitiatePayoutErrorEffects(error, "masspaySetup");
      return;
    }

    const response = yield api.postAuthMethod("masspay/initiatetable", {
      amount: payout.amount,
    });

    if (response.data.success) {
      yield put(initiatePayoutSuccess(response.data.data));
      yield push("wallet/payouts");
    } else {
      yield put(initiatePayoutFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield* putInitiatePayoutErrorEffects(error, "request");
  }
}

function* fetchPayoutServicesAPI() {
  try {
    const payout = yield select((state) => state.payoutModel.payout);
    const authentication = yield select(
      (state) => state.payoutModel.authentication.data
    );
    const response = yield api.postAuthMethod(
      "masspay/services",
      { country_code: payout.destinationCountry, amount: payout.amount },
      { headers: { Authorization: `Bearer ${authentication.access_token}` } }
    );

    if (response.data.success) {
      yield put(fetchPayoutServicesSuccess(response.data.data));
    } else {
      yield put(fetchPayoutServicesFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    if (error.response.status == 401) {
      yield push("/wallet");
    }
    yield put(fetchPayoutServicesFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchPayoutAttributesAPI() {
  try {
    const payout = yield select((state) => state.payoutModel.payout);
    const authentication = yield select(
      (state) => state.payoutModel.authentication.data
    );

    const response = yield api.postAuthMethod(
      "masspay/attributes",
      {
        destination_token: payout.destinationToken,
        destination_currency: payout.destinationCurrency,
      },
      { headers: { Authorization: `Bearer ${authentication.access_token}` } }
    );

    if (response.data.success) {
      yield put(fetchPayoutAttributesSuccess(response.data.data));
    } else {
      yield put(fetchPayoutAttributesFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    if (error.response.status == 401) {
      yield push("/wallet");
    }
    yield put(fetchPayoutAttributesFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchPayoutDraftAPI() {
  try {
    const payout = yield select((state) => state.payoutModel.payout);
    const uniqueId = yield select((state) => state.payoutModel.payoutData.unique_id);
    const attributes = yield select(
      (state) => state.payoutModel.attributes.data
    );
    const duplicatesAttributes = yield select(
      (state) => state.payoutModel.attributes.duplicatesAttributes
    );
    const authentication = yield select(
      (state) => state.payoutModel.authentication.data
    );
    let payload = {
      fee: payout.fee,
      attr_set_token: payout.attrSetToken,
      destination_token: payout.destinationToken,
      destination_currency: payout.destinationCurrency,
      amount: payout.amount,
      attrs: JSON.stringify(
        duplicatesAttributes.length
        ? duplicatesAttributes.map((at) => ({ token: at.token, value: at.value }))
        : attributes.map((at) => ({ token: at.token, value: at.value }))),
    }
    if (uniqueId) {
      payload.unique_id = uniqueId
    }
    const response = yield api.postAuthMethod(
      "masspay/payout-draft",
      payload,
      { headers: { Authorization: `Bearer ${authentication.access_token}` } }
    );

    if (response.data.success) {
      yield put(fetchPayoutDraftSuccess(response.data.data));
    } else {
      yield put(
        fetchPayoutDraftFailure(
          response.data.error || "An Error Occured, please retry later"
        )
      );
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    if (error.response.status == 401) {
      yield push("/wallet");
    }
    yield put(fetchPayoutDraftFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* confirmPayoutDraftAPI() {
  try {
    const payoutDraft = yield select(
      (state) => state.payoutModel.payoutDraft.data
    );
    const authentication = yield select(
      (state) => state.payoutModel.authentication.data
    );

    const response = yield api.postAuthMethod(
      "masspay/confirm-payout",
      { payout_token: payoutDraft.payout_token },
      { headers: { Authorization: `Bearer ${authentication.access_token}` } }
    );

    if (response.data.success) {
      yield put(confirmPayoutDraftSuccess(response.data.data));
      yield put(fetchWalletDetailsStart());

      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(masspayWithdrawSuccess(response.data.data));
    } else {
      yield put(confirmPayoutDraftFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
      yield put(masspayWithdrawFailed());
    }
  } catch (error) {
    if (error.response.status == 401) {
      yield push("/wallet");
    }

    yield put(confirmPayoutDraftFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* checkWithdrawalAmount() {
  const payoutDraft = yield select(
    (state) => state.payoutModel.payout
  );
  const checkAmount = (Number(payoutDraft.fee))
  const notificationMessage = getErrorNotificationMessage(`Withdrawal amount less than the fee (${checkAmount} USD)`);
  yield put(createNotification(notificationMessage));
}

function* initiateWithdrawalInvoiceDownload() {
  try {
    const downloadData = yield select(
      (state) => state.payoutModel.downloadData
    );
    yield invoiceService.downloadWithdrawalInvoice(downloadData.data);
    const notificationMessage = getSuccessNotificationMessage(`Withdrawal invoice downloaded`);
    yield put(createNotification(notificationMessage));
    yield put(fetchWithdrawalInvoiceEnd());
  } catch (error) {
    yield put(fetchWithdrawalInvoiceEnd());
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
  
}

export default function* payoutSaga() {
  yield all([yield takeLatest(INITIATE_PAYOUT_START, initiatePayoutActionAPI)]);
  yield all([
    yield takeLatest(FETCH_PAYOUT_SERVICES_START, fetchPayoutServicesAPI),
  ]);
  yield all([
    yield takeLatest(FETCH_PAYOUT_ATTRIBUTES_START, fetchPayoutAttributesAPI),
  ]);
  yield all([yield takeLatest(FETCH_PAYOUT_DRAFT_START, fetchPayoutDraftAPI)]);
  yield all([
    yield takeLatest(CONFIRM_PAYOUT_DRAFT_START, confirmPayoutDraftAPI),
  ]);
  yield all([
    yield takeLatest(INITIATE_PAYOUT_TABLE, initiateTablePayoutActionAPI),
    yield takeLatest(MASSPAY_WITHDRAW_AMOUNT_IS_LESS, checkWithdrawalAmount),
  ]);
  yield all([
    yield takeLatest(WITHDRAWAL_CONFIRM_DOWNLOAD_START, initiateWithdrawalInvoiceDownload),
  ]);
}
